export const OPEN_IMAGE_MODAL = 'modals/OPEN_IMAGE_MODAL';
export const CLOSE_IMAGE_MODAL = 'modals/CLOSE_IMAGE_MODAL';
export const OPEN_OBSERVATION_MODAL = 'modals/OPEN_OBSERVATION_MODAL';
export const CLOSE_OBSERVATION_MODAL = 'modals/CLOSE_OBSERVATION_MODAL';
export const OPEN_TRACK_MODAL = 'modals/OPEN_TRACK_MODAL';
export const CLOSE_TRACK_MODAL = 'modals/CLOSE_TRACK_MODAL';
